/**
 * Shipping rules — SINGLE SOURCE OF TRUTH.
 *
 * REGRA ATUAL: frete grátis UNIVERSAL — toda compra tem frete grátis para todo
 * o Brasil, sem valor mínimo. A tarifa de R$ 0,00 (zona Brasil, sem condição de
 * valor) está ativa no Shopify.
 *
 * ⚠️ Se um dia voltar a existir um valor mínimo, ele precisa ser alterado aqui,
 * no painel da Frenet/Shopify E no mirror em
 * `supabase/functions/shipping-quote/index.ts` — os três precisam estar
 * sincronizados ANTES de publicar.
 */
export const FREE_SHIPPING_THRESHOLD = 0;

/** Rótulo pronto para UI/marketing. */
export const FREE_SHIPPING_TEXT = 'Frete grátis';

/** Prazo oficial também publicado na FAQ. */
export const SHIPPING_ETA_TEXT = 'Chega em 3 a 5 dias úteis em capitais e regiões metropolitanas · 5 a 10 nas demais. Prazo exato no checkout.';

export interface FreeShippingProgress {
  current: number;
  target: number;
  remaining: number;
  percentage: number;
}

/**
 * Mantido apenas por compatibilidade de assinatura. Não há mais meta a atingir:
 * sempre retorna progresso completo.
 */
export function getFreeShippingProgress(subtotal: number): FreeShippingProgress {
  return {
    current: Math.max(0, subtotal || 0),
    target: 0,
    remaining: 0,
    percentage: 100,
  };
}

/** Frete grátis vale para qualquer compra. */
export function qualifiesForFreeShipping(_subtotal?: number): boolean {
  return true;
}
